export const getAttribute = (e, attr) => {
    const { currentTarget = document.body } = e;
    let { target } = e;
    while (target != currentTarget) {
        if (target && target.hasAttribute(attr))
            return target.getAttribute(attr);
        target = target.parentNode;
    }
    if (target && target.hasAttribute(attr))
        return target.getAttribute(attr);
    return null;
};
export const wrapComponent = (Component, props = {}, events = {}) => {
    return function (opts) {
        opts.props || (opts.props = {});
        Object.assign(opts.props, props);
        const comp = new Component(opts);
        Object.entries(events).every(([event, cb]) => {
            comp.$on(event, cb);
        });
        return comp;
    };
};
